import Vue from 'vue'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_CITIES,
  RECEIVING_CITIES,
  RECEIVE_CITY_METADATA,
  RECEIVE_CITY_FAILURE,
  SAVING_CITY,
  SAVING_CITY_FAILURE,
  UPDATING_CITY,
  UPDATING_CITY_FAILURE,
  DELETE_CITY,
  DELETING_CITY,
  DELETING_CITY_FAILURE,
  CLEAR_CITY_STATE,
  RESET_CITY_META,
  CLEAR_STATE,
  INCREMENT_CITY_COUNT
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import handleXHRError from '@/utils/helpers/HandleXHRError'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const citySchema = new schema.Entity('cities')
const cityListSchema = new schema.Array(citySchema)

const city = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  saveFailure: null,
  receivingData: false,
  receiveDataFailure: false,
  updating: null,
  updateFailure: null,
  deleting: false,
  deleteFailure: null
}

const actions = {
  fetchCitiesWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_CITIES, true)
    return Vue.http.get(buildUrlWithQuery('cities', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_CITIES, false)
        this.commit(RESET_CITY_META)
        if (!r.hasOwnProperty('results')) return this.commit(RECEIVE_CITY_FAILURE, 'Error fetching cities')
        const { results, next, previous, count } = r
        const { entities, result } = normalize(results, cityListSchema)
        this.commit(RECEIVE_CITIES, { data: entities.cities })
        this.commit(RECEIVE_CITY_METADATA, { next, previous, count, result: result.length })
        return { query, count, entities }
      })
      .catch(e => {
        this.commit(RECEIVING_CITIES, false)
        this.commit(RECEIVE_CITY_FAILURE, handleXHRError(e))
      })
  }
}

const getters = {
  getCities: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllCities: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getCityMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getCityById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getCityFetchStatus: (state) => {
    return state.receivingData
  },
  getCitySaveStatus: (state) => {
    return state.saving
  },
  getCityUpdateStatus: (state) => {
    return state.updating
  },
  getCityDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_CITIES] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_CITIES] (state, payload) {
    state.receivingData = payload
  },
  [RECEIVE_CITY_FAILURE] (state, error) {
    state.receiveDataFailure = error
  },
  [SAVING_CITY] (state, payload) {
    state.saving = payload
  },
  [SAVING_CITY_FAILURE] (state, payload) {
    state.saveFailure = payload
  },
  [UPDATING_CITY] (state, payload) {
    state.updating = payload
  },
  [UPDATING_CITY_FAILURE] (state, payload) {
    const { id, err } = payload
    state.updateFailure = { id, err }
  },
  [DELETE_CITY] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_CITY] (state, payload) {
    state.deleting = payload
  },
  [DELETING_CITY_FAILURE] (state, payload) {
    const { id, err } = payload
    state.deleteFailure = { id, err }
  },
  [INCREMENT_CITY_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_CITY_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_CITY_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_CITY_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  city,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/city.js